export default __webpack_public_path__ + "static/media/mgBG.ca64f1b9.svg";